import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { POI } from '../models/POI'

type poiState = {
  poiList: POI[]
  detailOpennedByMap: boolean
  displayPOIFinished: boolean
}

const slice = createSlice({
  name: 'poi',
  initialState: {
    poiList: [],
    detailOpennedByMap: false,
    displayPOIFinished: false
  } as poiState,
  reducers: {
    setPoiList: (
      state,
      { payload: { poiList } }: PayloadAction<{ poiList: POI[] }>
    ): void => {
      state.poiList = poiList
    },
    setDetailOpennedByMap: (
      state,
      {
        payload: { detailOpennedByMap }
      }: PayloadAction<{ detailOpennedByMap: boolean }>
    ): void => {
      state.detailOpennedByMap = detailOpennedByMap
    },
    setDisplayPOIFinished: (
      state,
      {
        payload: { displayPOIFinished }
      }: PayloadAction<{ displayPOIFinished: boolean }>
    ): void => {
      state.displayPOIFinished = displayPOIFinished
    }
  }
})

export const { setPoiList, setDetailOpennedByMap, setDisplayPOIFinished } =
  slice.actions

export default slice.reducer
